import { useMemo } from 'react';
import { Box } from '~/commonComponents/Box';
import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import { EmptyRecentProfessionals } from '~/components/ProfessionalsHub/components/RecentProfessionalsList/EmptyRecentProfessionals';
import { Colors } from '~/themes/colors';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { IUser } from '~/models';

export const RecentProfessionalTabPanel = ({
  isInviting,
  isLoading,
  selectedProfessionals,
  onClosePopup,
  onSelectProfessionals,
  onSentInvitations,
  isSelectionMode,
  profession,
  data = [],
}: IProfessionalTabPanelProps<IUser>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it: any) =>
        ({
          ...it,
          id: it?.professional?.id,
          full_name: it?.professional?.full_name,
          isAvailable: true,
          profession: it?.profession,
          profile_image: it?.professional?.image,
          professions: it?.professional?.professions,
        }) as IUser & { professions: string[] },
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      {!isEmpty && !isLoading && (
        <Text textAlign="center" italic color={Colors.neutral_500}>
          These are professionals who have recently worked at your office.
          <br />
          They will be confirmed once they accept the offer as listed.
        </Text>
      )}

      <Box flex={1}>
        <ProfessionalList
          EmptyComponent={
            <EmptyRecentProfessionals
              title="No Recent Professionals"
              description={
                <Text display="block" color={Colors.neutral_500} textAlign="center" width="100%">
                  It looks like you haven&apos;t completed any shifts yet! Once a professional
                  completes a shift, they will appear on this screen where you will able to send
                  direct invites to upcoming shifts.
                </Text>
              }
              width="100%"
              height="auto"
            />
          }
          isEmpty={isEmpty}
          isInviting={isInviting}
          isLoading={isLoading}
          professionals={professionals}
          selectedProfessionals={selectedProfessionals}
          selectedProfession={profession}
          onClose={onClosePopup}
          onSelectProfessionals={onSelectProfessionals}
          onSentInvitations={onSentInvitations}
          confirmButtonText={isSelectionMode ? 'Confirm' : undefined}
        />
      </Box>
    </Column>
  );
};
